class MapDots {
  constructor() {
    this._dots = [];
  }

  /**
   *
   * @param {MapDot} dot
   *
   * @return the id of the inserted row
   */
  add(dot) {
    this._dots.push(dot);

    return this._dots.length - 1;
  }

  set(dots) {
    this._dots = dots;
  }

  get() {
    return this._dots;
  }

  getPreviousDot(index) {
    if (index - 1 < 0) return null;

    return this._dots[index - 1];
  }

  getLastDotIndex() {
    if (this.total === 0) return null;

    return this._dots.length - 1;
  }

  removeByIndex(index) {
    this._dots.splice(index, 1);
  }

  get coordinates() {
    return this._dots.map(dot => dot.coordinates);
  }

  get total() {
    return this._dots.length;
  }
}

module.exports = MapDots;
